import { CompilationSortOption } from "@turtlewave/types";

import { useContentList } from "../../content/hooks/useContentList";

import { useCompilation } from "./useCompilation";

/**
 * Content previews for a compilation. The list waits for a resolved sort —
 * an explicit sortBy or the compilation's default — so it fetches once,
 * never provisionally.
 */
export function useCompilationContent(
  compilationId: string | null,
  sortBy?: CompilationSortOption,
) {
  const compilationQuery = useCompilation(compilationId);
  const sort = sortBy ?? compilationQuery.data?.default_sort;

  const contentListQuery = useContentList(
    compilationId ? { compilationId, sort } : undefined,
    { enabled: !compilationId || sort !== undefined },
  );

  return {
    compilation: compilationQuery.data,
    content: contentListQuery.data ?? [],
    isLoading: compilationQuery.isLoading || contentListQuery.isPending,
    error: compilationQuery.error || contentListQuery.error,
  };
}
